<template>
  <div class="app-company" v-if="userLoaded">
    <v-header :user="user" />
    <settings :user="user" />
    <manage-email-receivers v-if="userLoaded" :user="user" />
    <company-template :user="user" />
    <email-template :user="user" />
    <status-rights />
  </div>
</template>

<script>
import VHeader from "@/components/header";
import Settings from "@/components/admin/companies/CompanySettings.vue";
import StatusRights from "@/components/user/status-rights/StatusRightsManager";
import CompanyTemplate from "@/components/admin/companies/CompanyTemplates.vue";
import EmailTemplate from "@/components/admin/companies/TruckTemplateManager.vue";
import ManageEmailReceivers from "@/components/admin/companies/EmailReceiversManager.vue";
import User from "@/models/User.js";

// @ is an alias to /src
export default {
  name: "app-company",
  data() {
    return {
      userLoaded: false,
      user: new User(this.$session.get("user")),
    };
  },
  created() {
    this.checkUser(this.user);
    this.userLoaded = true;
  },
  methods: {
    checkUser(user) {
      if (this.user.company_id == 9) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
      if (![0, 1].includes(user["type"])) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
    },
  },
  components: {
    VHeader,
    StatusRights,
    CompanyTemplate,
    EmailTemplate,
    Settings,
    ManageEmailReceivers,
  },
};
</script>
